export interface SbirAgencyQueryKeyArgs {
  agencyId: string
}

export interface SbirAgenciesQueryKeyArgs {
  agencyIds: string[]
}

export interface SbirAgenciesSearchQueryKeyArgs {
  query: string
}

export const sbirAgencyQueryKey = {
  agency: (keyArgs: SbirAgencyQueryKeyArgs) =>
    ['sbir-agency', keyArgs.agencyId] as const,
}

export const sbirAgenciesQueryKey = {
  all: () => ['sbir-agencies'] as const,
  agencies: (keyArgs: SbirAgenciesQueryKeyArgs) =>
    ['sbir-agencies', ...keyArgs.agencyIds.toSorted()] as const,
  search: (keyArgs: SbirAgenciesSearchQueryKeyArgs) =>
    ['sbir-agencies', keyArgs.query] as const,
}

export interface SbirBranchQueryKeyArgs {
  branchId: string
}

export interface SbirBranchesQueryKeyArgs {
  branchIds: string[]
}

export interface SbirBranchesSearchQueryKeyArgs {
  query: string
}

export const sbirBranchQueryKey = {
  branch: (keyArgs: SbirBranchQueryKeyArgs) =>
    ['sbir-branch', keyArgs.branchId] as const,
}

export const sbirBranchesQueryKey = {
  all: () => ['sbir-branches'] as const,
  branches: (keyArgs: SbirBranchesQueryKeyArgs) =>
    ['sbir-branches', ...keyArgs.branchIds.toSorted()] as const,
  search: (keyArgs: SbirBranchesSearchQueryKeyArgs) =>
    ['sbir-branches', keyArgs.query] as const,
}

export interface SbirTopicBranchQueryKeyArgs {
  topicBranchId: string
}

export interface SbirTopicBranchesQueryKeyArgs {
  topicBranchIds: string[]
}

export interface SbirTopicBranchesSearchQueryKeyArgs {
  query: string
}

export const sbirTopicBranchQueryKey = {
  topicBranch: (keyArgs: SbirTopicBranchQueryKeyArgs) =>
    ['sbir-topic-branch', keyArgs.topicBranchId] as const,
}

export const sbirTopicBranchesQueryKey = {
  all: () => ['sbir-topic-branches'] as const,
  topicBranches: (keyArgs: SbirTopicBranchesQueryKeyArgs) =>
    ['sbir-topic-branches', ...keyArgs.topicBranchIds.toSorted()] as const,
  search: (keyArgs: SbirTopicBranchesSearchQueryKeyArgs) =>
    ['sbir-topic-branches', keyArgs.query] as const,
}
